module.exports = __webpack_public_path__ + "static/media/total-time.55aa970e.png";